import { scaleLinear } from 'd3-scale';
import { createContext } from 'react';

import { YAxisScales } from '../types/state.js';

export const TimeseriesChartYScalesContext = createContext<YAxisScales>({
  left: { scale: scaleLinear() },
});

TimeseriesChartYScalesContext['displayName'] = 'TimeseriesChartYScalesContext';
